import React, { useState } from "react";
import {
  Input,
  TextField,
  Typography,
} from "@mui/material";
import * as XLSX from "xlsx";
import TableHeader from "components/Table/TableHeader";
import TableElement from "components/Table/TableElement";
import { ActionButton, FormCard, TableCard } from "utils/ui";

const Whatsapp = () => {
  const [userData, setUserData] = useState([]);
  const [message, setMessage] = useState("");

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const headers = XLSX.utils.sheet_to_json(sheet, {
          header: 1,
          range: 0,
        })[0];

        const jsonData = XLSX.utils.sheet_to_json(sheet, {
          header: headers,
          range: 1,
        });

        setUserData(jsonData);
      };

      reader.readAsArrayBuffer(file);
    } else {
      setUserData([]);
    }
  };

  return (
    <FormCard>
      <div className="relative flex flex-col justify-start items-center break-words w-full">
        <Typography
          sx={{ paddingY: 2, textAlign: "center" }}
          variant="h4"
          gutterBottom
        >
          Whatsapp Message Sender
        </Typography>
        <div className="md:w-1/2 w-full px-1">
          <TextField
            sx={{ marginBottom: "15px" }}
            fullWidth
            multiline={true}
            variant="standard"
            label={
              <span className="text-sm md:text-base font-medium">Message</span>
            }
            InputProps={{
              sx: {
                fontSize: {
                  xs: "12px",
                  sm: "13px",
                  md: "13px",
                  lg: "16px",
                },
              },
            }}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>
        <Input
          key={userData.length}
          type="file"
          accept=".xlsx, .xls"
          onChange={handleFileChange}
          style={{ display: "none" }}
          id="file-input"
        />
        <div className="flex flex-col justify-center items-center">
          <div className="flex justify-center w-full md:w-1/2 mb-4">
            <label htmlFor="file-input" className="w-full">
              <ActionButton icon="fas fa-plus">
                Upload Excel File
              </ActionButton>
            </label>
          </div>
          <span className="capitalize text-center">
            upload a excel file containg coloum "name" and "mobile" in small case
          </span>
          <ActionButton 
            onClick={() => {
              setUserData([]);
              setMessage("");
            }}
            className="mt-4"
          >
            Reset
          </ActionButton>
        </div>

        <TableCard className="w-full mt-8">
          <div className="overflow-x-auto">
            <table className="py-4 items-center w-full bg-transparent border-collapse">
              <thead className="bg-gray-300">
                <tr className="divide-x divide-gray-200">
                  <TableHeader heading="" />
                  <TableHeader heading="Name" />
                  <TableHeader heading="Mobile " />
                  <TableHeader heading="Send" />
                </tr>
              </thead>
              <tbody>
                {userData &&
                  userData.map((e, i) => {
                    return (
                      <tr
                        key={i + 1}
                        style={{ transition:"background 100ms" }} onMouseEnter={(e)=>e.currentTarget.style.background="#F8FAFC"} onMouseLeave={(e)=>e.currentTarget.style.background="transparent"}
                      >
                        <TableElement value={i + 1} />
                        <TableElement value={e.name} />
                        <TableElement value={e.mobile} />
                        <TableElement
                          value={
                            <a
                              href={`https://api.whatsapp.com/send?phone=+91${e.mobile}&text=${message}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="text-sm text-blue-400 hover:text-blue-700">
                                SEND
                              </span>
                            </a>
                          }
                          type="element"
                        />
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </TableCard>
      </div>
    </FormCard>
  );
};

export default Whatsapp;
